import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getPersonnelAdjustmentByProjectId } from 'apis/personnelAdjustment.api';

const useGetPersonnelAdjustmentByProjectId = (projectId, conds = {}) => {
  const { data: personnelAdjustmentsData, ...rest } = useQuery(
    ['getPersonnelAdjustmentByProjectId', projectId],
    () => getPersonnelAdjustmentByProjectId(projectId),
    {
      ...conds,
    }
  );

  const personnelAdjustments = useMemo(
    () => personnelAdjustmentsData?.data ?? [],
    [personnelAdjustmentsData]
  );

  return {
    data: personnelAdjustments,
    ...rest,
  };
};

export default useGetPersonnelAdjustmentByProjectId;
